import React, { Component } from "react";
import { Col, Row, Table } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import { getFullName } from "../../helpers/functions/employee";

class LeaveBalanceReport extends Component {
    render() {
        const { reportData, year } = this.props;

        return (
            <Row>
                <div style={{ marginTop: "60px" }} />
                <Col md={12}>
                    <Card
                        title="Leave Balance Report"
                        category={`${year} annual entitlements and cash-conversion balances`}
                        ctTableFullWidth
                        ctTableResponsive
                        content={
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Employee</th>
                                        <th>Leave type</th>
                                        <th>Initial</th>
                                        <th>Monthly accrual</th>
                                        <th>Used</th>
                                        <th>Pending</th>
                                        <th>Left</th>
                                        <th>Cash conversion</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData && reportData.length ? (
                                        reportData.reduce(
                                            (rows, employeeBalance) => {
                                                const balances = Object.values(
                                                    employeeBalance.balances,
                                                );
                                                balances.forEach(
                                                    (balance, index) => {
                                                        rows.push(
                                                            <tr
                                                                key={`${employeeBalance.employee._id}-${balance.leaveType}`}
                                                            >
                                                                {index === 0 && (
                                                                    <td
                                                                        rowSpan={
                                                                            balances.length
                                                                        }
                                                                    >
                                                                        {getFullName(
                                                                            employeeBalance.employee,
                                                                        )}
                                                                        <div className="text-muted">
                                                                            {
                                                                                employeeBalance
                                                                                    .employee
                                                                                    .employeeNumber
                                                                            }
                                                                        </div>
                                                                        {employeeBalance.source &&
                                                                            !employeeBalance
                                                                                .source
                                                                                .payLevelConfigured && (
                                                                                <div className="text-warning">
                                                                                    Pay level allowance not configured
                                                                                </div>
                                                                            )}
                                                                    </td>
                                                                )}
                                                                <td>
                                                                    {
                                                                        balance.label
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        balance.initial
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        balance.monthlyEntitlement
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        balance.used
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        balance.pending
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <strong>
                                                                        {
                                                                            balance.remaining
                                                                        }
                                                                    </strong>
                                                                </td>
                                                                <td>
                                                                    {
                                                                        balance.payoutSchedule
                                                                    }
                                                                </td>
                                                            </tr>,
                                                        );
                                                    },
                                                );
                                                return rows;
                                            },
                                            [],
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="8">
                                                No results found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default LeaveBalanceReport;
